import styled from '@mint-lib/styled';

import Box from '../Box/Box.jsx';
import { ButtonProps } from '../Button/Button.jsx';
import Collapse from '../Collapse/Collapse.jsx';
import Typography from '../Typography/Typography.jsx';
import ProcessingModalHeader, {
  ProcessingModalHeaderProps,
} from './ProcessingModalHeader/ProcessingModalHeader.jsx';

export interface BtnProps extends ButtonProps {
  label?: string;
}

export interface ProcessingModalProps extends ProcessingModalHeaderProps {
  children?: React.ReactNode;
  leftSubheaderText?: string;
  rightSubheaderText?: string;
}

const ProcessingModal = ({
  processingStatus,
  children,
  leftSubheaderText,
  rightSubheaderText,
  ...props
}: ProcessingModalProps) => {
  return (
    <ProcessingModalRoot>
      <ProcessingModalHeader processingStatus={processingStatus} {...props} />
      {leftSubheaderText || rightSubheaderText ? (
        <ProcessingShortInfo>
          <Typography variant="bodyShort01">{leftSubheaderText}</Typography>
          <Typography variant="bodyShort01">{rightSubheaderText}</Typography>
        </ProcessingShortInfo>
      ) : null}
      <Collapse in={props.isModalExpanded} timeout="auto" unmountOnExit>
        {props.isModalExpanded ? (
          <ProcessingListWrapper>{children}</ProcessingListWrapper>
        ) : null}
      </Collapse>
    </ProcessingModalRoot>
  );
};

export default ProcessingModal;

const ProcessingModalRoot = styled(Box)`
  width: 25rem;
  box-shadow: 0px 0px 8px 0px rgba(34, 37, 43, 0.24);
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.ui.primary};
  border: ${({ theme }) => `1px solid ${theme.palette.border.tertiary}`};
`;
const ProcessingShortInfo = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2rem;
  padding: 8px 16px;
  border-radius: 0px 0px 8px 8px;
`;
const ProcessingListWrapper = styled(Box)`
  width: 100%;
  max-height: 20rem;
  overflow: auto;
  border-radius: 0px 0px 8px 8px;
`;
